module.exports = __webpack_public_path__ + "img/8.6c83b702.png";